import { SetStateAction, useState } from 'react';

import { BackgroundImage, Badge, Card, Flex, Modal, Stack, Text } from 'ui';
import { PrizePlaceholderGradient } from 'ui/Icons';

import { CampaignPrize } from '../../../api/new/types/prizes';

const PrizeCardHeader = ({ src, children }: { src?: string; children?: JSX.Element }) => {
  return (
    <BackgroundImage src={src || ''} mih={172}>
      {children}
    </BackgroundImage>
  );
};

const PrizeCard = ({
  prize,
  setIsModalOpen,
}: {
  prize?: CampaignPrize | undefined;
  setIsModalOpen?: React.Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <Card onClick={() => setIsModalOpen?.(true)} mih={228} withBorder style={{ cursor: 'pointer' }}>
      <Card.Section>
        <BackgroundImage src={prize?.image?.url || PrizePlaceholderGradient} mih={172}>
          <PrizeCardHeader src={prize?.image?.url ?? PrizePlaceholderGradient} />
          <Flex w="fit-content" pos="absolute" top={0} m="sm">
            <Badge fullWidth type="success" variant="filled">
              {prize?.badge}
            </Badge>
          </Flex>
        </BackgroundImage>
      </Card.Section>
      <Stack gap="xs" mt="md">
        <Text size="md" fw={600} lineClamp={1}>
          {prize?.title}
        </Text>
      </Stack>
    </Card>
  );
};

export const PrizeCardModal = ({ prize }: { prize: CampaignPrize }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <PrizeCard prize={prize} setIsModalOpen={setIsModalOpen} />
      <Modal.Root
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        styles={{ body: { padding: 0 } }}
      >
        <Modal.Overlay />
        <Modal.Content>
          <Modal.ImageHeader src={prize.image?.url ?? PrizePlaceholderGradient} aspectRatio={2 / 1}>
            <Badge type="success" variant="filled">
              {prize.badge}
            </Badge>

            <Modal.CloseButton variant="white" size="md" />
          </Modal.ImageHeader>

          <Modal.Body p="md">
            <Text size="md" fw={600}>
              {prize.title}
            </Text>
            <Text size="sm">{prize.description}</Text>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
};
